<template>
  <span>data-queries</span>
</template>
<script>
export default {};
</script>
